<script setup lang="ts">
import type { CombinedError } from '@urql/vue';
import {
  any, bool, object, string,
} from 'vue-types';

import AlertError from './AlertError.vue';
import Loading from '../Loading.vue';

defineProps({
  fetching: Boolean,
  error: object<CombinedError>(),
  class: any(),
  title: string(),
  spinner: bool().def(true),
});
</script>

<template>
  <Loading v-if="fetching && spinner" :title="title" :class="$props.class">
    <template #default>
      <slot />
    </template>
  </Loading>
  <AlertError v-else-if="error" :error="error" :class="$props.class" />
  <div v-else :class="$props.class">
    <slot name="error">
      Something went wrong
    </slot>
  </div>
</template>
